// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";

// const img_base_url = "https://api.rrludo.in"; // backend base URL

// const QrManagement = () => {
//   const [upiList, setUpiList] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [formData, setFormData] = useState({
//     upiId: "",
//     limitFrom: "",
//     limitTo: "",
//     qrImage: null,
//   });

//   const [limits, setLimits] = useState({ gatewayMin: "", gatewayMax: "" });


//   const fetchUpiList = async () => {
//     try {
//       const { data } = await axios.get(`${img_base_url}/upi/getUpiAll`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`, // Agar auth token use ho raha hai
//         },
//       });
//       if (data.status) setUpiList(data.data);
//     } catch (err) {
//       console.error(err);
//       Swal.fire({ title: "Failed to fetch UPI list", icon: "error" });
//     }
//   };

//   useEffect(() => {
//     fetchUpiList();
//     fetchLimits();
//   }, []);

//   const handleAddUpi = async () => {
//     if (!formData.upiId || !formData.limitFrom || !formData.limitTo || !formData.qrImage) {
//       Swal.fire({ title: "All fields are required", icon: "warning" });
//       return;
//     }

//     try {
//       const newForm = new FormData();
//       newForm.append("upiId", formData.upiId);
//       newForm.append("limitFrom", formData.limitFrom);
//       newForm.append("limitTo", formData.limitTo);
//       newForm.append("qrImage", formData.qrImage);

//       const { data } = await axios.post(`${img_base_url}/upi/addUpi`, newForm, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       if (data.status) {
//         Swal.fire({ title: "UPI Added Successfully", icon: "success" });
//         setFormData({ upiId: "", limitFrom: "", limitTo: "", qrImage: null });
//         setShowModal(false);
//         fetchUpiList();
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({ title: "Failed to add UPI", icon: "error" });
//     }
//   };

//   const handleDelete = async (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This will remove UPI permanently!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Delete it",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const { data } = await axios.delete(`${img_base_url}/upi/delete/${id}`, {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           });
//           if (data.status) {
//             Swal.fire({ title: "Deleted!", icon: "success" });
//             fetchUpiList();
//           }
//         } catch (err) {
//           console.error(err);
//           Swal.fire({ title: "Failed to delete UPI", icon: "error" });
//         }
//       }
//     });
//   };


//   // Fetch Limits
//   const fetchLimits = async () => {
//     try {
//       const { data } = await axios.get(`${img_base_url}/upi/limits`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//       });
//       if (data.status) setLimits(data.data);
//     } catch {
//       Swal.fire("Error", "Failed to fetch limits", "error");
//     }
//   };





//   return (
//     <div className="container mt-4">
//       {/* Header */}


//       {/* Table */}
//       <div className="table-responsive shadow-sm rounded">
//         <table className="table table-bordered table-hover align-middle">
//           <thead className="table-dark">
//             <tr>
//               <th>UPI ID</th>
//               <th>QR Code</th>
//               <th>Limit</th>
//               <th className="text-center">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {upiList.length > 0 ? (
//               upiList.map((item) => (
//                 <tr key={item._id}>
//                   <td>{item.upiId}</td>
//                   <td className="text-center">
//                     <img
//                       src={`${img_base_url}${item.qrImage}`}
//                       alt="qr"
//                       style={{
//                         width: "50px",
//                         height: "50px",
//                         objectFit: "contain",
//                         borderRadius: "8px",
//                         border: "1px solid #ddd",
//                         padding: "2px",
//                         backgroundColor: "#fff",
//                       }}
//                     />
//                   </td>
//                   <td>
//                     {item.limitFrom} - {item.limitTo}
//                   </td>
//                   <td className="text-center">
//                     <button className="btn btn-danger btn-sm px-3" onClick={() => handleDelete(item._id)}>
//                       🗑 Delete
//                     </button>
//                     <button className="btn btn-danger btn-sm px-3" onClick={() => setShowModal(true)}>
//                        ➕ Add UPI
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" className="text-center py-3">
//                   No UPI Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>



//       {/* Modal */}
//       {showModal && (
//         <div
//           className="position-fixed top-0 start-0  d-flex justify-content-center align-items-center"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
//           onClick={() => setShowModal(false)}
//         >
//           <div
//             className="bg-white p-4 rounded shadow-lg"
//             style={{ maxWidth: "400px", width: "95%" }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <h5 className="mb-3 text-center fw-bold text-primary">Add New UPI</h5>

//             <input
//               type="text"
//               placeholder="Enter UPI ID"
//               className="form-control mb-3"
//               value={formData.upiId}
//               onChange={(e) => setFormData({ ...formData, upiId: e.target.value })}
//             />

//             <div className="d-flex gap-2 mb-3">
//               <input
//                 type="number"
//                 placeholder="Min Limit"
//                 className="form-control"
//                 value={formData.limitFrom}
//                 onChange={(e) => setFormData({ ...formData, limitFrom: e.target.value })}
//               />
//               <input
//                 type="number"
//                 placeholder="Max Limit"
//                 className="form-control"
//                 value={formData.limitTo}
//                 onChange={(e) => setFormData({ ...formData, limitTo: e.target.value })}
//               />
//             </div>

//             <input
//               type="file"
//               className="form-control mb-3"
//               accept="image/*"
//               onChange={(e) => setFormData({ ...formData, qrImage: e.target.files[0] })}
//             />

//             <div className="d-flex justify-content-between">
//               <button className="btn btn-outline-secondary w-50 me-2" onClick={() => setShowModal(false)}>
//                 Cancel
//               </button>
//               <button className="btn btn-success w-50" onClick={handleAddUpi}>
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default QrManagement;


import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaTrash, FaPlus, FaMoneyBillWave } from "react-icons/fa"; // Imported icons for better UI

const img_base_url = "https://api.rrludo.in"; // backend base URL

const QrManagement = () => {
  const [upiList, setUpiList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    upiId: "",
    limitFrom: "",
    limitTo: "",
    qrImage: null,
  });

  // Limits state and fetch function are handled correctly.
  const [limits, setLimits] = useState({ gatewayMin: "", gatewayMax: "" });

  const fetchUpiList = async () => {
    try {
      const { data } = await axios.get(`${img_base_url}/upi/getUpiAll`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (data.status) setUpiList(data.data);
    } catch (err) {
      console.error(err);
      Swal.fire({ title: "Failed to fetch UPI list", icon: "error" });
    }
  };

  const fetchLimits = async () => {
    try {
      const { data } = await axios.get(`${img_base_url}/upi/limits`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (data.status) setLimits(data.data);
    } catch {
      Swal.fire("Error", "Failed to fetch limits", "error");
    }
  };

  useEffect(() => {
    fetchUpiList();
    fetchLimits();
  }, []);

  const handleAddUpi = async () => {
    if (!formData.upiId || !formData.limitFrom || !formData.limitTo || !formData.qrImage) {
      Swal.fire({ title: "All fields are required", icon: "warning" });
      return;
    }

    try {
      const newForm = new FormData();
      newForm.append("upiId", formData.upiId);
      newForm.append("limitFrom", formData.limitFrom);
      newForm.append("limitTo", formData.limitTo);
      newForm.append("qrImage", formData.qrImage);

      const { data } = await axios.post(`${img_base_url}/upi/addUpi`, newForm, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (data.status) {
        Swal.fire({ title: "UPI Added Successfully", icon: "success" });
        setFormData({ upiId: "", limitFrom: "", limitTo: "", qrImage: null });
        setShowModal(false);
        fetchUpiList();
      }
    } catch (err) {
      console.error(err);
      Swal.fire({ title: "Failed to add UPI", icon: "error" });
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will remove UPI permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { data } = await axios.delete(`${img_base_url}/upi/delete/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          if (data.status) {
            Swal.fire({ title: "Deleted!", icon: "success" });
            fetchUpiList();
          }
        } catch (err) {
          console.error(err);
          Swal.fire({ title: "Failed to delete UPI", icon: "error" });
        }
      }
    });
  };


  // --- COMPONENT RETURN ---
  return (
    <div className="container mt-4 mb-5">
      
      {/* 🚀 Header and Add UPI Button */}
      <div className="d-flex justify-content-between align-items-center mb-4 p-3 bg-white shadow-sm rounded">
        <h3 className="mb-0 text-primary fw-bold">QR Management</h3>
        <button 
          className="btn btn-primary d-flex align-items-center fw-bold" 
          onClick={() => setShowModal(true)}
        >
          <FaPlus className="me-2" /> Add New UPI
        </button>
      </div>
      
      {/* 💰 Limits Display */}
     
      
      {/* 📋 UPI List Table */}
      <div className="table-responsive shadow-lg rounded">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th className="text-white" style={{width: '40%'}}>UPI ID</th>
              <th className="text-center text-white" style={{width: '20%'}}>QR Code</th>
              <th className="text-white" style={{width: '20%'}}>Limit (Min-Max)</th>
              <th className="text-center text-white" style={{width: '20%'}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {upiList.length > 0 ? (
              upiList.map((item) => (
                <tr key={item._id}>
                  <td className="fw-medium">{item.upiId}</td>
                  <td className="text-center">
                    <img
                      src={`${img_base_url}${item.qrImage}`}
                      alt="qr"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "contain",
                        borderRadius: "8px",
                        border: "1px solid #007bff", // Blue border for focus
                        padding: "3px",
                        backgroundColor: "#fff",
                        boxShadow: '0 0 5px rgba(0, 123, 255, 0.2)'
                      }}
                    />
                  </td>
                  <td>
                    <span className="badge bg-success p-2">
                        ₹{item.limitFrom} - ₹{item.limitTo}
                    </span>
                  </td>
                  <td className="text-center">
                    <button 
                      className="btn btn-danger btn-sm px-3 d-flex align-items-center mx-auto" 
                      onClick={() => handleDelete(item._id)}
                    >
                      <FaTrash className="me-1" /> Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-4 bg-light text-muted">
                  No UPIs added yet. Click 'Add New UPI' to begin.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      
      {/* ➕ Add New UPI Modal */}
      {showModal && (
        <div
          className="modal d-block" 
          tabIndex="-1" 
          style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1050 }}
          onClick={() => setShowModal(false)}
        >
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title fw-bold">Add New UPI Gateway</h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                    <label className="form-label fw-bold">UPI ID</label>
                    <input
                      type="text"
                      placeholder="e.g. yourname@bank"
                      className="form-control"
                      value={formData.upiId}
                      onChange={(e) => setFormData({ ...formData, upiId: e.target.value })}
                    />
                </div>
                
                <div className="row g-2 mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-bold">Min Limit</label>
                    <input
                      type="number"
                      placeholder="Min Limit"
                      className="form-control"
                      value={formData.limitFrom}
                      onChange={(e) => setFormData({ ...formData, limitFrom: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">Max Limit</label>
                    <input
                      type="number"
                      placeholder="Max Limit"
                      className="form-control"
                      value={formData.limitTo}
                      onChange={(e) => setFormData({ ...formData, limitTo: e.target.value })}
                    />
                  </div>
                </div>

                <div className="mb-4">
                    <label className="form-label fw-bold">Upload QR Code Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={(e) => setFormData({ ...formData, qrImage: e.target.files[0] })}
                    />
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <button className="btn btn-outline-danger w-45" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-success w-45" onClick={handleAddUpi}>
                  <FaPlus className="me-1"/> Save UPI
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
    </div>
  );
};

export default QrManagement;